import SwitchUiLanguage from "@ext/localization/actions/SwitchUiLanguage";

const TopMenuSwitchUiLanguageButton = () => <SwitchUiLanguage size="lg" />;

export default TopMenuSwitchUiLanguageButton;
